// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSHeader/ABSPerson/index.less
// module id = 735
// module chunks = 42